import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

interface LoadingScreenProps {
  message?: string
  size?: number
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = 'Loading...', 
  size = 50 
}) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
        padding: 3,
      }}
    >
      <CircularProgress 
        size={size} 
        color="primary" 
        sx={{ mb: 2 }}
      />
      <Typography 
        variant="body1" 
        color="textSecondary"
        sx={{ textAlign: 'center' }}
      >
        {message}
      </Typography>
    </Box>
  )
}

export default LoadingScreen
